module.exports = __webpack_public_path__ + "static/media/slide3.1189a029.jpg";